export const translations = {
  zh: {
    nav_home: "首頁",
    nav_features: "功能特色",
    nav_technology: "技術架構",
    nav_users: "應用場景",
    nav_benefits: "預期效益",
    nav_team: "團隊介紹",
    nav_roadmap: "發展藍圖",
    nav_cta: "立即體驗",
    hero_title: "AI 智慧發音教練",
    hero_subtitle: "讓你自信開口說出完美英語！",
    hero_button_primary: "觀看演示",
    hero_button_secondary: "了解更多",
    stat_1_number: "50萬+",
    stat_1_label: "預期服務家庭",
    stat_2_number: "3,000+",
    stat_2_label: "目標企業客戶",
    stat_3_number: "34",
    stat_3_label: "支援語言數",
    stat_4_label: "AI驅動智慧發音評估",
    features_title: "核心功能特色",
    features_subtitle: "整合多項 AI 技術，提供全方位的英語發音學習解決方案",
    feature_1_title: "智慧發音評估",
    feature_1_desc: "基於 Microsoft Azure 語音服務，提供準確度、流暢度、完整度、韻律四維度評分",
    feature_1_items: ["即時錄音評估", "音素級別分���", "可調整嚴格程度", "詳細錯誤偵測"],
    feature_2_title: "AI 智慧助理",
    feature_2_desc: "個人化學習建議，根據發音評估結果提供專業改進方案",
    feature_2_items: ["學習建議", "錯誤分析", "練習推薦", "圖文輸入支援"],
    feature_3_title: "多元文字輸入",
    feature_3_desc: "支援手動輸入、語音轉文字、OCR 圖片識別等多種輸入方式",
    feature_3_items: ["手動輸入", "語音轉文字", "OCR 識別", "智慧格式化"],
    feature_4_title: "語音合成播放",
    feature_4_desc: "多種 AI 語音角色，支援語速調節，提供標準發音示範",
    feature_4_items: ["多語音選擇", "語速調節", "標準示範", "自然流暢"],
    feature_5_title: "收藏標籤系統",
    feature_5_desc: "智慧收藏管理，自訂標籤分類，支援批次操作",
    feature_5_items: ["一鍵收藏", "標籤管理", "分類篩選", "批次操作"],
    feature_6_title: "雲端分享同步",
    feature_6_desc: "跨裝置資料同步，安全的雲端分享機制",
    feature_6_items: ["雲端分享", "跨裝置同步", "版本控制", "隱私保護"],
    tech_title: "技術架構",
    tech_subtitle: "採用最新 AI 技術，構建穩定可靠的學習平台",
    tech_stack_title: "前端技術堆疊",
    tech_stack_1: "現代化使用者介面框架",
    tech_stack_2: "型別安全的 JavaScript 超集",
    tech_stack_3: "響應式設計和 iOS 風格介面",
    tech_stack_4: "音訊錄製和處理",
    tech_dependencies_title: "核心相依套件",
    tech_breakdown_title: "核心檔案功能分析",
    tech_breakdown_subtitle: "本平台由多個高度內聚的模組構成，展現了我們在現代Web應用開發中的技術深度與廣度。以下為專案中最重要的核心檔案解析：",
    file_analysis_1_title: "`src/pages/PronunciationAssessment.tsx` (112.7 KB)",
    file_analysis_1_subtitle: "核心應用程式協調器 (Core Application Orchestrator)",
    file_analysis_1_desc: "此檔案是整個產品的<b>大腦與心臟</b>，其設計展現了我們構建複雜、高內聚、可擴展應用的核心技術能力。它不僅僅是一個UI頁面，而是一個精密的<b>狀態機</b>與<b>服務協調器</b>。",
    file_analysis_1_item_1: "<b>多維度狀態管理</b>: 精準管理超過20個獨立的應用狀態，從用戶身份驗證、API設定，到即時的評分結果、學習歷程與UI互動狀態，確保數據流的穩定與一致。",
    file_analysis_1_item_2: "<b>模組化架構</b>: 作為總指揮，它優雅地整合了超過15個獨立的功能模組（如AI助理、收藏列表、分享引擎等），實現了高度的功能解耦與可維護性，為未來快速的功能擴展奠定了堅實的基礎。",
    file_analysis_1_item_3: "<b>動態功能路由</b>: 透過`useEffect`鉤子，實現了基於URL參數的智慧路由功能，能處理自動登入、載入分享教材、啟動AI助理等多種深度連結（Deep Linking）場景，是實現病毒式行銷與用戶無縫引導的关键。",
    file_analysis_1_item_4: "<b>即時數據同步</b>: 內建與Firebase的即時監聽器（`onSnapshot`），確保用戶數據在多裝置間的無縫、即時同步，並設計了精巧的數據鏡像機制（`latestUpdateRef`）以防止無限循環更新，保障了系統的穩定性。",
    file_analysis_1_item_5: "<b>複雜使用者流程處理</b>: 完整實現了從錄音、串流評估、結果呈現、歷史紀錄儲存到AI分析建議的完整閉環使用者流程，並包含了針對不同瀏覽器環境（如iOS內嵌瀏覽器）的優雅降級與提示方案。",
    file_analysis_1_conclusion: "此檔案的規模與其內部的邏輯複雜度，直接證明了我們團隊在打造企業級、功能豐富的��頁應用（SPA）方面的頂尖實力。",
    file_analysis_2_title: "`src/components/ShareData.tsx` (41.4 KB)",
    file_analysis_2_subtitle: "協作與病毒式傳播引擎 (Collaboration & Virality Engine)",
    file_analysis_2_desc: "此元件是我們實現<b>用戶增長</b>與<b>社群生態</b>的關鍵技術。它提供了一套完整的數據分享、匯入、匯出及備份機制，其核心價值在於：",
    file_analysis_2_item_1: "<b>病毒式傳播迴路</b>: 允許用戶將個人學習內容（如單字卡、練習句）一鍵生成分享連結，透過社群網路傳播，新用戶可透過連結無縫匯入教材，形成強大的用戶獲取與增長迴路。",
    file_analysis_2_item_2: "<b>B2B場景賦能</b>: 為教育機構、企業內訓提供了標準化的教材分發與版本控制方案，教師可輕鬆建立課程包，分發給學生，並透過編輯密碼進行後續更新。",
    file_analysis_2_item_3: "<b>數據資產保障</b>: 提供完整的JSON匯出與匯入功能，保障用戶的學習數據資產100%可攜，大幅提升用戶的信任感與長期使用的黏著度。",
    file_analysis_3_title: "`src/components/AIDataProcessor.tsx` (30.9 KB)",
    file_analysis_3_subtitle: "個人化AI學習引擎 (Personalized AI Learning Engine)",
    file_analysis_3_desc: "這是我們實現「<b>適性化智慧家教</b>」願景的核心技術模組。它封裝了與後端大型語言模型（LLM）的複雜互動邏輯，能根據用戶的發音歷史、學習目標，甚至上傳的圖片，動態生成高度客製化的學習內容。此引擎的<b>多模態輸入</b>（文字、圖片、發音歷史）能力，是我們產品的關鍵差異化優勢，將傳統的單向練習，提升為真正個人化的雙向互動學習體驗。",
    file_analysis_4_title: "`src/components/FavoriteList.tsx` (30.4 KB)",
    file_analysis_4_subtitle: "使用者學習資產管理系統 (User Learning Asset Management System)",
    file_analysis_4_desc: "我們將用戶的學習內容視為其寶貴的<b>數位資產</b>。此元件提供了一套強大的個人化學習庫（Personal Knowledge Base）管理功能，包含智慧收藏、多維度標籤分類、以及高效的即時搜尋篩選機制。它不僅僅是個列表，而是幫助用戶建立、管理並活用其個人知識庫的核心工具，是培養用戶長期學習習慣、提升平台<b>生命週期價值（LTV）</b>的關鍵設計。",
    file_analysis_5_title: "`src/utils/firebaseStorage.ts` (17.3 KB)",
    file_analysis_5_subtitle: "雲端同步與使用者設定檔服務 (Cloud Sync & User Profile Service)",
    file_analysis_5_desc: "此模組是實現<b>跨裝置無縫體驗</b>的基石。它深度整合了Firebase/Firestore，負責所有使用者數據（包括學習記錄、偏好設定、收藏內容）的即時雲端同步。我們設計了一套包含<b>重試機制</b>與<b>網路狀態檢查</b>的強韌（Resilient）數據同步方案，確保用戶無論在哪個裝置、何種網路環境下，都能接續上一次的學習進度，是打造平台生態系不可或缺的一環。",
    file_analysis_6_title: "`src/hooks/useAzureSpeech.ts` (16.3 KB)",
    file_analysis_6_subtitle: "核心語音分析引擎 (Core Speech Analysis Engine)",
    file_analysis_6_desc: "這是我們產品最核心的<b>技術護城河</b>，直接整合了微軟Azure的頂級語音辨識服務。此模組封裝了複雜的SDK互動，將全球領先的語音評估技術轉化為簡單易用的API供前端調用。它提供的<b>精準音素級別分析</b>，是我們能夠提供專業級發音回饋的根本，構成了我們產品最難以被複製的技術壁壘。",
    users_title: "應用場景",
    users_subtitle: "服務���元使用者群體，滿足不同學習需求",
    user_1_title: "備考學生群體",
    user_1_desc: "面臨聽力理解困難與口說恐懼的雙重挑戰",
    user_1_solution_title: "解決方案：",
    user_1_solutions: ["安全的個人化練習環境", "多維度發音評估了解錯誤位置", "AI 智慧助理提供改進建議", "語音合成支援多種語速調節"],
    user_1_impact_title: "預期影響：",
    user_1_impact: "預期提升口說成績平均 20%，獲得 40% 市場佔有率",
    user_2_title: "工作忙碌的職業父母",
    user_2_desc: "面臨子女英語學習輔導困境",
    user_2_solution_title: "解決方案：",
    user_2_solutions: ["OCR 文字辨識技術拍攝課文自動生成練習", "Microsoft Azure 語音服務多維度評估", "AI 智慧助理個人化建議", "學習歷程保留功能"],
    user_2_impact_title: "預期影響：",
    user_2_impact: "預期服務全台超過 50 萬個家庭",
    user_3_title: "赴海外工作專業人士",
    user_3_desc: "面臨專業術語發音訓練資源匱乏",
    user_3_solution_title: "解決方案：",
    user_3_solutions: ["支援專業術語輸入", "AI 自動生成相關情境句子", "標籤管理系統按產業別分類", "雲端同步跨裝置學習進度"],
    user_3_impact_title: "預期影響：",
    user_3_impact: "特別適合電子業等特殊領域從業人員",
    user_4_title: "醫療機構管理者",
    user_4_desc: "面臨同仁專業英語溝通能力不足問題",
    user_4_solution_title: "解決方案：",
    user_4_solutions: ["醫療專業英語訓練模組", "健檢流程對話練習", "醫療術語發音訓練", "跨文化溝通技巧培訓"],
    user_4_impact_title: "預期影響：",
    user_4_impact: "預期服務全台 500 家醫療機構，年創造 5 億元營收",
    benefits_title: "預期效益",
    benefits_subtitle: "創造龐大商業價值，推動台灣邁向國際化數位學習社會",
    benefit_1_category: "教育領域",
    benefit_1_metrics: [{ metric: "40-60%", desc: "學生英語口說能力提升" }, { metric: "50萬", desc: "預期服務家庭數量" }, { metric: "15-20分鐘", desc: "家長每日投入時間" }],
    benefit_2_category: "企業培訓",
    benefit_2_metrics: [{ metric: "200億元", desc: "台灣年英語培訓市場" }, { metric: "20%", desc: "預期市場佔有率" }, { metric: "40億元", desc: "預期年營收" }],
    benefit_3_category: "社會影響",
    benefit_3_metrics: [{ metric: "30-50%", desc: "偏鄉學生英語能力提升" }, { metric: "前5名", desc: "台灣英��能力亞洲排名目標" }, { metric: "125萬", desc: "新住民及外籍移工服務對象" }],
    expansion_title: "未來擴展效益",
    expansion_1_title: "多語言平台發展",
    expansion_1_desc: "34種語言支援",
    expansion_1_target: "10年內服務全球1,000萬使用者",
    expansion_1_revenue: "年營收500億元",
    expansion_2_title: "VR學習生態建構",
    expansion_2_desc: "VR英語學習環境",
    expansion_2_target: "開創沉浸式學習市場",
    expansion_2_revenue: "創造100億元新興市場價值",
    expansion_3_title: "企業White Label服務",
    expansion_3_desc: "專屬語言學習系統",
    expansion_3_target: "服務1,000家機構客戶",
    expansion_3_revenue: "年營收100億元",
    team_title: "團隊介紹",
    team_subtitle: "經驗豐富的創業團隊，結合學術背景與實務經驗",
    member_1_name: "王意騏",
    member_1_role: "創辦人",
    member_1_edu: "國立政治大學資訊管理學系研究所畢業 (2008-2009)",
    member_1_exp: "宏煜國際貿易股份有限公司創辦人 (2010至今)",
    member_2_name: "蕭伊貽",
    member_2_role: "行銷主管",
    member_2_edu: "國立政治大學資訊管理學系研究所畢業 (2009-2010)",
    member_2_exp: "宏煜國際貿易股份有限���司行銷主管 (2010至今)",
    member_3_name: "王楷珩",
    member_3_role: "未來使用者代表",
    member_3_edu: "再興小學一年級就讀中 (2024-2025)",
    member_3_exp: "代表新世代學習者觀點",
    detail_label_edu: "學歷：",
    detail_label_exp: "經歷：",
    roadmap_title: "發展藍圖",
    roadmap_subtitle: "持續創新，引領語言學習技術發展",
    roadmap_section_1_title: "已實作完成",
    roadmap_section_1_items: ["智慧發音評估", "AI智慧助理系統", "語音合成與多語音技術", "多模態文字輸入"],
    roadmap_section_2_title: "即將推出",
    roadmap_section_2_items: [
      { title: "多語言介面支援", desc: "支援34種語言學習", status: "開發中" },
      { title: "語音對話練習", desc: "即時AI對話互動", status: "測試階段" },
      { title: "社群學習功能", desc: "學習夥伴配對", status: "設計階段" },
      { title: "遊戲成就激勵系統", desc: "AI動態難度調整", status: "開發中" },
      { title: "虛擬化身AVATAR", desc: "增加學習真實性", status: "規劃中" },
      { title: "AI客製化PODCAST", desc: "24小時個人化內容", status: "概念驗證" },
    ],
    roadmap_section_3_title: "長期規劃",
    roadmap_section_3_items: [
      { title: "企業White Label服務", desc: "服務企業內訓或學習組織，提供客製化解決方案", timeline: "2-3年內", impact: "預期服務1,000家機構" },
      { title: "VR英文學習環境", desc: "結合VEO3 SORA等AI影像生成，創造沉浸式學習體驗", timeline: "3-5年內", impact: "開創100億元新興市場" },
    ],
    cta_title: "準備好開始您的發音學習之旅了嗎？",
    cta_subtitle: "加入我們，體驗最先進的 AI 發音評估技術，讓英語學習更精準、更有效",
    cta_button_primary: "立即體驗",
    cta_button_secondary: "聯繫我們",
    footer_desc: "nicetone.ai - 基於 Microsoft Azure 語音服務的智慧發音評估平台，提供專業的英語發音分析、學習管理和資料分享功能。",
    footer_copyright: "© 2025 nicetone.ai. All rights reserved.",
    footer_links_1_title: "產品功能",
    footer_links_1_items: ["智慧發音評估", "AI 智慧助理", "語音合成播放", "雲端分享同步"],
    footer_links_2_title: "聯繫資訊",
    footer_links_2_items: ["台灣", "ifanoski@gmail.com", "創立於 2010 年"],
  },
  en: {
    nav_home: "Home",
    nav_features: "Features",
    nav_technology: "Technology",
    nav_users: "Use Cases",
    nav_benefits: "Benefits",
    nav_team: "Team",
    nav_roadmap: "Roadmap",
    nav_cta: "Try Now",
    hero_title: "AI-Powered Pronunciation Coach",
    hero_subtitle: "Speak English Confidently and Perfectly!",
    hero_button_primary: "Watch Demo",
    hero_button_secondary: "Learn More",
    stat_1_number: "500K+",
    stat_1_label: "Families to be Served",
    stat_2_number: "3,000+",
    stat_2_label: "Target Enterprise Clients",
    stat_3_number: "34",
    stat_3_label: "Supported Languages",
    stat_4_label: "AI-Driven Pronunciation Assessment",
    features_title: "Core Features",
    features_subtitle: "Integrating multiple AI technologies to provide a comprehensive English pronunciation learning solution.",
    feature_1_title: "Intelligent Pronunciation Assessment",
    feature_1_desc: "Based on Microsoft Azure Speech Service, providing four-dimensional scoring for accuracy, fluency, completeness, and prosody.",
    feature_1_items: ["Real-time recording assessment", "Phoneme-level analysis", "Adjustable strictness", "Detailed error detection"],
    feature_2_title: "AI Smart Assistant",
    feature_2_desc: "Personalized learning suggestions and professional improvement plans based on pronunciation assessment results.",
    feature_2_items: ["Learning suggestions", "Error analysis", "Practice recommendations", "Image and text input support"],
    feature_3_title: "Diverse Text Input",
    feature_3_desc: "Supports manual input, speech-to-text, and OCR image recognition.",
    feature_3_items: ["Manual input", "Speech-to-text", "OCR recognition", "Smart formatting"],
    feature_4_title: "Speech Synthesis Playback",
    feature_4_desc: "Multiple AI voice roles with adjustable speech rate for standard pronunciation demonstration.",
    feature_4_items: ["Multiple voice options", "Adjustable speech rate", "Standard demonstration", "Natural and fluent"],
    feature_5_title: "Favorites & Tagging System",
    feature_5_desc: "Smart management of favorites with custom tags and batch operations.",
    feature_5_items: ["One-click favorite", "Tag management", "Category filtering", "Batch operations"],
    feature_6_title: "Cloud Sharing & Sync",
    feature_6_desc: "Cross-device data synchronization with a secure cloud sharing mechanism.",
    feature_6_items: ["Cloud sharing", "Cross-device sync", "Version control", "Privacy protection"],
    tech_title: "Technology Architecture",
    tech_subtitle: "Built on the latest AI technology to create a stable and reliable learning platform.",
    tech_stack_title: "Frontend Tech Stack",
    tech_stack_1: "Modern user interface framework",
    tech_stack_2: "Type-safe JavaScript superset",
    tech_stack_3: "Responsive design and iOS-style interface",
    tech_stack_4: "Audio recording and processing",
    tech_dependencies_title: "Core Dependencies",
    tech_breakdown_title: "Core File Functionality Analysis",
    tech_breakdown_subtitle: "Our platform is composed of multiple, highly-cohesive modules, demonstrating our technical depth and breadth in modern web application development. Here is an analysis of the most critical files in the project:",
    file_analysis_1_title: "`src/pages/PronunciationAssessment.tsx` (112.7 KB)",
    file_analysis_1_subtitle: "Core Application Orchestrator",
    file_analysis_1_desc: "This file is the <b>brain and heart</b> of the entire product, showcasing our core technical capability in building complex, cohesive, and scalable applications. It's not just a UI page but a sophisticated <b>state machine</b> and <b>service coordinator</b> responsible for:",
    file_analysis_1_item_1: "<b>Multi-dimensional State Management</b>: Precisely manages over 20 independent application states, from user authentication and API settings to real-time scoring results, learning history, and UI interaction states, ensuring data flow stability and consistency.",
    file_analysis_1_item_2: "<b>Modular Architecture</b>: As the central hub, it elegantly integrates over 15 independent functional modules (like the AI Assistant, Favorite List, Share Engine, etc.), achieving high functional decoupling and maintainability, laying a solid foundation for rapid future feature expansion.",
    file_analysis_1_item_3: "<b>Dynamic Feature Routing</b>: Utilizes `useEffect` hooks for smart routing based on URL parameters, handling various deep-linking scenarios like automatic login, loading shared materials, and activating the AI assistant, which is key to viral marketing and seamless user onboarding.",
    file_analysis_1_item_4: "<b>Real-time Data Sync</b>: Features a built-in real-time listener (`onSnapshot`) with Firebase to ensure seamless, instantaneous data synchronization across user devices, with a clever data mirroring mechanism (`latestUpdateRef`) to prevent infinite update loops and guarantee system stability.",
    file_analysis_1_item_5: "<b>Complex User Flow Handling</b>: Implements the complete closed-loop user flow from recording, streaming assessment, result presentation, history saving, to AI analysis and suggestions, including graceful degradation and prompts for different browser environments (like iOS in-app browsers).",
    file_analysis_1_conclusion: "The scale and logical complexity of this file directly prove our team's top-tier ability in building enterprise-grade, feature-rich Single Page Applications (SPAs).",
    file_analysis_2_title: "`src/components/ShareData.tsx` (41.4 KB)",
    file_analysis_2_subtitle: "Collaboration & Virality Engine",
    file_analysis_2_desc: "This component is the key technology for achieving <b>user growth</b> and building a <b>community ecosystem</b>. It provides a complete suite for data sharing, importing, exporting, and backup, with its core value in:",
    file_analysis_2_item_1: "<b>Viral Loop</b>: Allows users to generate a shareable link for their personal learning content (like flashcards, practice sentences) with one click, spreading it through social networks. New users can seamlessly import materials via the link, creating a powerful user acquisition and growth loop.",
    file_analysis_2_item_2: "<b>B2B Enablement</b>: Provides a standardized solution for material distribution and version control for educational institutions and corporate training. Teachers can easily create course packages, distribute them to students, and perform subsequent updates using an edit password.",
    file_analysis_2_item_3: "<b>Data Asset Protection</b>: Offers full JSON export and import functionality, ensuring 100% portability of user learning data assets, which significantly enhances user trust and long-term engagement.",
    file_analysis_3_title: "`src/components/AIDataProcessor.tsx` (30.9 KB)",
    file_analysis_3_subtitle: "Personalized AI Learning Engine",
    file_analysis_3_desc: "This is the core technology module for realizing our vision of an '<b>adaptive smart tutor</b>.' It encapsulates the complex interaction logic with the backend Large Language Model (LLM), dynamically generating highly customized learning content based on the user's pronunciation history, learning goals, and even uploaded images. The <b>multi-modal input</b> capability (text, images, pronunciation history) of this engine is a key differentiating advantage of our product, elevating traditional one-way practice to a truly personalized, interactive learning experience.",
    file_analysis_4_title: "`src/components/FavoriteList.tsx` (30.4 KB)",
    file_analysis_4_subtitle: "User Learning Asset Management System",
    file_analysis_4_desc: "We treat user's learning content as their valuable <b>digital assets</b>. This component provides a powerful management system for a Personal Knowledge Base, including smart favoriting, multi-dimensional tagging, and efficient real-time search and filtering. It's not just a list but a core tool that helps users build, manage, and actively use their personal knowledge base, which is key to fostering long-term learning habits and increasing the platform's <b>Lifetime Value (LTV)</b>.",
    file_analysis_5_title: "`src/utils/firebaseStorage.ts` (17.3 KB)",
    file_analysis_5_subtitle: "Cloud Sync & User Profile Service",
    file_analysis_5_desc: "This module is the cornerstone for a <b>seamless cross-device experience</b>. It is deeply integrated with Firebase/Firestore and is responsible for the real-time cloud synchronization of all user data, including learning records, preferences, and favorite content. We have designed a resilient data synchronization solution that includes a <b>retry mechanism</b> and <b>network status checks</b>, ensuring that users can pick up where they left off, regardless of the device or network conditions, making it an indispensable part of building our platform ecosystem.",
    file_analysis_6_title: "`src/hooks/useAzureSpeech.ts` (16.3 KB)",
    file_analysis_6_subtitle: "Core Speech Analysis Engine",
    file_analysis_6_desc: "This is one of our product's core <b>technical moats</b>, directly integrating Microsoft Azure's top-tier speech recognition service. This module encapsulates complex SDK interactions, transforming world-leading speech assessment technology into a simple, easy-to-use API for the frontend. The <b>precision phoneme-level analysis</b> it provides is fundamental to our ability to offer professional-grade pronunciation feedback and constitutes our most defensible technical barrier.",
    users_title: "Use Cases",
    users_subtitle: "Serving diverse user groups to meet different learning needs.",
    user_1_title: "Test-prep Students",
    user_1_desc: "Facing dual challenges of listening comprehension difficulties and speaking anxiety.",
    user_1_solution_title: "Solutions:",
    user_1_solutions: ["Safe, personalized practice environment", "Multi-dimensional pronunciation assessment to identify errors", "AI assistant providing improvement suggestions", "Speech synthesis with adjustable speed"],
    user_1_impact_title: "Expected Impact:",
    user_1_impact: "Projected 20% average increase in speaking scores, capturing 40% market share.",
    user_2_title: "Busy Working Parents",
    user_2_desc: "Struggling with guiding their children's English learning.",
    user_2_solution_title: "Solutions:",
    user_2_solutions: ["OCR technology to generate exercises from textbook photos", "Multi-dimensional assessment via Microsoft Azure", "Personalized suggestions from AI assistant", "Learning history tracking"],
    user_2_impact_title: "Expected Impact:",
    user_2_impact: "Expected to serve over 500,000 families in Taiwan.",
    user_3_title: "Professionals Working Abroad",
    user_3_desc: "Lacking resources for professional terminology pronunciation training.",
    user_3_solution_title: "Solutions:",
    user_3_solutions: ["Support for professional terminology input", "AI-generated contextual sentences", "Tagging system for industry-specific classification", "Cross-device learning progress sync"],
    user_3_impact_title: "Expected Impact:",
    user_3_impact: "Especially suitable for professionals in fields like electronics.",
    user_4_title: "Healthcare Administrators",
    user_4_desc: "Facing inadequate professional English communication skills among staff.",
    user_4_solution_title: "Solutions:",
    user_4_solutions: ["Medical English training modules", "Health check-up dialogue practice", "Medical terminology pronunciation training", "Cross-cultural communication skills training"],
    user_4_impact_title: "Expected Impact:",
    user_4_impact: "Expected to serve 500 healthcare institutions in Taiwan, generating NT$500 million in annual revenue.",
    benefits_title: "Expected Benefits",
    benefits_subtitle: "Creating immense business value and advancing Taiwan towards an international digital learning society.",
    benefit_1_category: "Education Sector",
    benefit_1_metrics: [{ metric: "40-60%", desc: "Improvement in students' English speaking skills" }, { metric: "500K", desc: "Expected number of families served" }, { metric: "15-20 min", desc: "Daily time investment by parents" }],
    benefit_2_category: "Corporate Training",
    benefit_2_metrics: [{ metric: "NT$20B", desc: "Annual English training market in Taiwan" }, { metric: "20%", desc: "Expected market share" }, { metric: "NT$4B", desc: "Projected annual revenue" }],
    benefit_3_category: "Social Impact",
    benefit_3_metrics: [{ metric: "30-50%", desc: "Improvement in rural students' English skills" }, { metric: "Top 5", desc: "Goal for Taiwan's English proficiency ranking in Asia" }, { metric: "1.25M", desc: "New immigrants and foreign workers served" }],
    expansion_title: "Future Expansion Benefits",
    expansion_1_title: "Multi-language Platform Development",
    expansion_1_desc: "Support for 34 languages",
    expansion_1_target: "Serve 10 million global users within 10 years",
    expansion_1_revenue: "Annual revenue of NT$50 billion",
    expansion_2_title: "VR Learning Ecosystem Construction",
    expansion_2_desc: "VR English learning environment",
    expansion_2_target: "Pioneer the immersive learning market",
    expansion_2_revenue: "Create NT$10 billion in new market value",
    expansion_3_title: "Enterprise White Label Service",
    expansion_3_desc: "Customized language learning systems",
    expansion_3_target: "Serve 1,000 institutional clients",
    expansion_3_revenue: "Annual revenue of NT$10 billion",
    team_title: "Our Team",
    team_subtitle: "An experienced entrepreneurial team combining academic background with practical experience.",
    member_1_name: "Wang, Yi-Chi",
    member_1_role: "Founder",
    member_1_edu: "M.S. in Information Management, National Chengchi University (2008-2009)",
    member_1_exp: "Founder of Hong Yu International Trade Co., Ltd. (2010-Present)",
    member_2_name: "Hsiao, Yi-Yi",
    member_2_role: "Marketing Director",
    member_2_edu: "M.S. in Information Management, National Chengchi University (2009-2010)",
    member_2_exp: "Marketing Director at Hong Yu International Trade Co., Ltd. (2010-Present)",
    member_3_name: "Wang, Kai-Heng",
    member_3_role: "Future User Representative",
    member_3_edu: "First Grade, Tsai Hsing Elementary School (2024-2025)",
    member_3_exp: "Represents the perspective of new-generation learners",
    detail_label_edu: "Education:",
    detail_label_exp: "Experience:",
    roadmap_title: "Roadmap",
    roadmap_subtitle: "Continuously innovating to lead the development of language learning technology.",
    roadmap_section_1_title: "Implemented",
    roadmap_section_1_items: ["Intelligent Pronunciation Assessment", "AI Smart Assistant System", "Speech Synthesis & Multi-voice Tech", "Multi-modal Text Input"],
    roadmap_section_2_title: "Coming Soon",
    roadmap_section_2_items: [
      { title: "Multi-language Interface Support", desc: "Support for 34 languages", status: "In Development" },
      { title: "Voice Dialogue Practice", desc: "Real-time AI conversation interaction", status: "Testing Phase" },
      { title: "Community Learning Features", desc: "Learning partner matching", status: "Design Phase" },
      { title: "Gamified Achievement System", desc: "AI dynamic difficulty adjustment", status: "In Development" },
      { title: "Virtual Avatar", desc: "Increase learning realism", status: "Planning" },
      { title: "AI-customized Podcast", desc: "24/7 personalized content", status: "Proof of Concept" },
    ],
    roadmap_section_3_title: "Long-term Vision",
    roadmap_section_3_items: [
      { title: "Enterprise White Label Service", desc: "Provide customized solutions for corporate training or learning organizations", timeline: "Within 2-3 years", impact: "Serve 1,000 institutions" },
      { title: "VR English Learning Environment", desc: "Create immersive learning experiences by integrating AI video generation services like VEO3 SORA", timeline: "Within 3-5 years", impact: "Create a new market worth NT$10 billion" },
    ],
    cta_title: "Ready to start your pronunciation learning journey?",
    cta_subtitle: "Join us to experience the most advanced AI pronunciation assessment technology and make your English learning more precise and effective.",
    cta_button_primary: "Try Now",
    cta_button_secondary: "Contact Us",
    footer_desc: "nicetone.ai - An intelligent pronunciation assessment platform based on Microsoft Azure Speech Service, providing professional English pronunciation analysis, learning management, and data sharing features.",
    footer_copyright: "© 2025 nicetone.ai. All rights reserved.",
    footer_links_1_title: "Product Features",
    footer_links_1_items: ["Intelligent Assessment", "AI Assistant", "TTS Playback", "Cloud Sync"],
    footer_links_2_title: "Contact Info",
    footer_links_2_items: ["Taiwan", "ifanoski@gmail.com", "Founded in 2010"],
  }
};
